import React from "react";

const AnalysisSuccesfull = ({
  isAnalysisSuccesfullOpen,
  navigateToLoanApprasialReport,
}) => {
  return (
    <>
      <div
        className={`${
          isAnalysisSuccesfullOpen ? "flex" : "hidden"
        } flex items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="flex items-center justify-center min-h-[50%] w-full">
          <div className="relative bg-white shadow-lg p-6 rounded-sm w-[40%]  mx-auto">
            <div className="flex items-center justify-center">
              <svg
                width="53"
                height="53"
                viewBox="0 0 53 53"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="53" height="53" rx="26.5" fill="#BFE0FD" />
                <path
                  d="M11 32L20.7544 38.7761L39.43 17.9347"
                  stroke="#074073"
                  stroke-width="3"
                  stroke-linecap="round"
                />
              </svg>
            </div>

            <div className="text-center text-[#060606] text-[16px] font-[600] mt-5">
              Success! Analysis Complete
            </div>

            <p className="text-center text-[#000000] text-[16px] font-normal">
              Your statement report is ready.
            </p>
            <div className="flex items-center justify-center mt-8 mb-8">
              <button
                onClick={navigateToLoanApprasialReport}
                type="submit"
                className="px-8 py-2 rounded-[6px] text-white font-medium cursor-pointer  bg-[#074073]"
              >
                View Analysis Report
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AnalysisSuccesfull;
